import styled from 'styled-components';

export const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (min-width: 480px) {
    flex-direction: row;
  }
`;

export const CourseThumbnail = styled.img`
  width: 100%;
  max-width: 296px;
  margin-bottom: 24px;
  border-radius: 8px;

  @media screen and (min-width: 800px) {
    max-width: 240px;
    margin-right: 32px;
    margin-bottom: 0;
  }
`;

export const ResponsivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: 800px) {
    flex-direction: row;
  }
`;

export const CourseInformation = styled.div`
  margin-right: 24px;
  margin-bottom: 24px;

  @media screen and (min-width: 480px) {
    margin-bottom: 0;
  }

  @media screen and (min-width: 800px) {
    margin-right: 0;
  }

  .course-name,
  .course-description,
  .complementary-info {
    font-family: var(--font-sans);
    color: var(--color-black);
  }

  .course-name {
    font-size: 1.953rem;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .complementary-info {
    display: flex;
    font-size: 1.25rem;
    margin-bottom: 16px;

    & > :not(:last-child) {
      margin-right: 16px;
    }
  }

  .course-description {
    font-weight: 300;
  }
`;

export const CourseOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and (min-width: 880px) {
    flex-direction: row;
  }

  @media screen and (min-width: 480px) {
    margin-left: 16px;
  }

  .button-icon {
    min-width: 24px;
  }

  .delete-button,
  .bulk-edit-button,
  .edit-button {
    font-family: var(--font-sans);
    font-size: 1rem;
    font-weight: 500;

    height: fit-content;
    width: 100%;
    margin-bottom: 8px;

    @media screen and (min-width: 880px) {
      margin-bottom: 0;
    }
  }
  .bulk-edit-button {
    min-width: 180px;
  }

  .delete-button {
    margin-right: 8px;
    color: var(--color-red);
  }

  .edit-button {
    color: var(--color-black);
  }
`;
